<script setup>
import OpenCardComponent from '@/components/cards/OpenCardComponent.vue'
import { useRoomStore } from '@/stores/room'
const roomStore = useRoomStore()

</script>

<template>
  <div class="flex flex-row my-8 gap-4 justify-center self-center fixed bottom-0 cursor-default">
    <div v-for="card, index in roomStore.cards" :key="index">
      <OpenCardComponent @click="roomStore.onVote(index)" :isSelected="index === roomStore.myVote"
        :disabled="roomStore.isRevealed || roomStore.isSpectating">{{ card }}</OpenCardComponent>
    </div>
  </div>
</template>
